//deps
import React, { memo, ReactElement } from "react";

//interfaces
import { OffersProps } from "@payment-ui/interfaces";

//test-ids
import { SWIGGY_MONEY_OFFERS_TEST_IDS } from "@swiggy-private/payment-test-ids";

//styles
import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import { Container, OfferCode, OfferContainer, OfferIconContainer, OfferIconImg } from "./styles";

interface OfferIconProps {
    size?: number;
}

const DEFAULT_OFFER_ICON_HEIGHT = 20;
function OfferIcon(props: OfferIconProps): ReactElement {
    const { size = DEFAULT_OFFER_ICON_HEIGHT } = props;
    return (
        <OfferIconImg
            aria-hidden="true"
            crossOrigin="anonymous"
            src={getCloudinaryUrl("4_0_Assets/Money/AddMoneyOffers.png")}
            width={size}
            height={size}
        />
    );
}

function Offers(props: OffersProps): ReactElement | null {
    const { offers } = props;
    if (!offers.length) return null;
    return (
        <Container data-testid={SWIGGY_MONEY_OFFERS_TEST_IDS.CONTAINER}>
            {offers.map((offer, index) => {
                return (
                    <OfferContainer key={index}>
                        <OfferIconContainer data-testid={SWIGGY_MONEY_OFFERS_TEST_IDS.CONTENT_ITEM}>
                            <OfferIcon data-testid={SWIGGY_MONEY_OFFERS_TEST_IDS.ICON} />
                            <OfferCode
                                variant="V2.body2.neutral.medium"
                                color="text_Med_Emphasis"
                                data-testid={SWIGGY_MONEY_OFFERS_TEST_IDS.TITLE}
                            >
                                {offer}
                            </OfferCode>
                        </OfferIconContainer>
                    </OfferContainer>
                );
            })}
        </Container>
    );
}

export default memo(Offers);
